module.exports = __webpack_public_path__ + "media/images/emblems/Bruettelen-coat_of_arms-01f991a6933ccfcfd46a693eb67c3ab3.svg";